import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, isRef as _isRef, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, TransitionGroup as _TransitionGroup, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6beeb762"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "frontline-dashboard-mobile" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "safe-area-inset-top" }, null, -1))
const _hoisted_3 = {
  key: "fm-dash-header",
  class: "section section--header"
}
const _hoisted_4 = {
  "data-testid": "fm-dash-welcome-message",
  class: "welcome-message"
}
const _hoisted_5 = { class: "dashboard-filter-bar" }
const _hoisted_6 = {
  key: "fm-dash-responses",
  class: "section section--row"
}
const _hoisted_7 = {
  key: "fm-dash-praise-actions",
  class: "section"
}
const _hoisted_8 = {
  key: "fm-dash-detractor-actions",
  class: "section"
}
const _hoisted_9 = {
  key: "fm-dash-scorecard-cases",
  class: "section section--row"
}
const _hoisted_10 = {
  key: "fm-dash-team-leaderboard",
  class: "section"
}

import {
    computed,
    type ComputedRef,
    onBeforeMount,
    onMounted,
    onUnmounted,
} from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { useToast } from 'primevue/usetoast'
import Toast from 'primevue/toast'
import {
    faFaceFrownSlight,
    faUserGroup,
} from 'fontawesome/pro-regular-svg-icons'
import { Style } from '@capacitor/status-bar'
import { setStatusBarStyle } from '@/mobile/src/utils/capacitor'
import { useFrontlineManagerDash } from '@/composables/useFrontlineManagerDash'
import { tabletBreakpoint } from '@/utils/breakpoints'
import { TimeOptionLabel } from '@/utils/time'
import ScoreGraphCard from '@/components/FrontlineManagerDash/ScoreGraphCard.vue'
import ResponsesSummary from '@/components/FrontlineManagerDash/ResponsesSummary.vue'
import FilterBarQuestionType from '@/components/PrimeVue/FilterBarQuestionType.vue'
import FilterBarTime from '@/components/PrimeVue/FilterBarTime.vue'
import ActionsList from '@/components/FrontlineManagerDash/ActionsList.vue'
import Cases from '@/components/FrontlineManagerDash/Cases.vue'
import Scorecard from '@/components/FrontlineManagerDash/Scorecard.vue'
import LeaderboardTable from '@/components/FrontlineManagerDash/LeaderboardTable.vue'
import PraiseModal from '@/components/FrontlineManagerDash/PraiseModal.vue'
import { useModal } from '@/composables/useModal'
import { RecommendedAction } from '@/entities/frontlineManagerDash'


export default /*#__PURE__*/_defineComponent({
  __name: 'FrontlineManagerDashboardMobile',
  setup(__props) {

const store = useStore()
const router = useRouter()
const toast = useToast()

const {
    graphData,
    graphSummary,
    responseSummary,
    responseCount,
    teamLeaderboard,
    loadingResponseData,
    loadingPromoterActions,
    loadingDetractorActions,
    loadingTeamLeaderboard,
    hasErrorResponseData,
    hasErrorPromoterActions,
    hasErrorDetractorActions,
    hasErrorTeamLeaderboard,
    metricFilter,
    timeFilter,
    isPageLoading,
    promoterActions,
    detractorActions,
    tags,
    installedApps,
    selectedPraise,
    showPraiseActionsCard,
    showDetractorActionsCard,
    scorecards,
    loadingScorecardData,
    hasErrorScorecardData,
    cases,
    loadingCasesData,
    casesResponseCount,
    hasErrorCasesData,
    fetchPageData,
    welcomeMessage,
    fetchResponses,
    setTimeFilter,
    saveTimeFilter,
    fetchTeamLeaderboard,
    fetchActionsPromoter,
    fetchActionsDetractor,
    onDismissPraise,
    onDismissDetractor,
    onStoreDetractor,
    onPraiseSent,
    onPraiseSendFailed,
    onPraiseSendWarn,
    fetchScorecardData,
    fetchCasesData,
} = useFrontlineManagerDash(toast.add)

const {
    isModalOpen: isPraiseModalOpen,
    openModal: setPraiseModalOpen,
    closeModal: closePraiseModal,
} = useModal()

const userName = computed(() => store.getters['userName'])
const companyVars = computed(() => store.getters['$companyVars'])
const activeMetrics = computed(() => store.getters['activeMetrics'])
const savedTimeFilter = computed(
    () => store.getters['getCopilotDashboardFilters']
)

const isFiveScore = computed(() => {
    return metricFilter.value && metricFilter.value !== 'nps'
})
const showCsatAsPercent = computed(() => {
    return (
        metricFilter.value == 'csat' &&
        companyVars.value?.has_display_csat_as_percentage
    )
})

const actionCardsToShow: ComputedRef<number> = computed(() =>
    window.innerWidth >= tabletBreakpoint ? 2 : 3
)

onBeforeMount(async () => {
    await store.dispatch('getFilters') //Make sure the user lock filters are loaded
    metricFilter.value = store.getters.filterQuestionType ?? 'nps'

    if (savedTimeFilter.value) {
        setTimeFilter(savedTimeFilter.value)
    }

    await fetchPageData()
})

onMounted(async () => {
    await setStatusBarStyle(Style.Light)
})

onUnmounted(async () => {
    await setStatusBarStyle(Style.Dark)
})

const onFilterChange = async (timeOption?: TimeOptionLabel) => {
    if (timeOption) {
        saveTimeFilter(timeOption)
    }

    await fetchPageData()
}

const openPraiseModal = (action: RecommendedAction) => {
    selectedPraise.value = action
    setPraiseModalOpen()
}

const openChat = async (action: RespondAction, index: number) => {
    if (action.can_respond) {
        onStoreDetractor(action, index)
    }
    await router.push({
        name: 'feedbackdetail',
        params: { feedbackid: action.question_id },
    })
}

const onViewCasesClicked = async () => {
    await store.dispatch('setFilterRule', {
        id: store.getters.mobileFilterActive.id,
        rule: {
            column: 'case',
            operator: 'in',
            source: 'general',
            value: ['overdue'],
        },
    })

    if (timeFilter.value) {
        await store.dispatch('setFilterTime', {
            id: store.getters.mobileFilterActive.id,
            time_unit: timeFilter.value.time_unit,
            time_value: timeFilter.value.time_value,
        })
    }

    router.push({ name: 'myfeedback' })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_unref(Toast), { position: "bottom-center" }),
    _createVNode(PraiseModal, {
      visible: _unref(isPraiseModalOpen),
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => (_isRef(isPraiseModalOpen) ? (isPraiseModalOpen).value = $event : null)),
      "praise-action": _unref(selectedPraise),
      "installed-apps": _unref(installedApps),
      tags: _unref(tags),
      "show-carousel-indicators": false,
      "is-mobile": true,
      onClose: _unref(closePraiseModal),
      onCompleteAction: _unref(onPraiseSent),
      onErrorDuringAction: _unref(onPraiseSendFailed),
      onWarnDuringAction: _unref(onPraiseSendWarn)
    }, null, 8, ["visible", "praise-action", "installed-apps", "tags", "onClose", "onCompleteAction", "onErrorDuringAction", "onWarnDuringAction"]),
    _createVNode(_TransitionGroup, { name: "dashboard-layout" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h1", _hoisted_4, _toDisplayString(_unref(welcomeMessage)(userName.value)), 1),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(FilterBarTime, {
              modelValue: _unref(timeFilter),
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(timeFilter) ? (timeFilter).value = $event : null)),
              disabled: _unref(isPageLoading),
              "data-testid": "fm-dash-time-filter",
              onFilterChanged: onFilterChange
            }, null, 8, ["modelValue", "disabled"]),
            _createVNode(FilterBarQuestionType, {
              modelValue: _unref(metricFilter),
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(metricFilter) ? (metricFilter).value = $event : null)),
              disabled: _unref(isPageLoading),
              "active-metrics": activeMetrics.value,
              "is-multi-metric": 
                            !!companyVars.value?.has_lead_with_any_question
                        ,
              onFilterChanged: onFilterChange
            }, null, 8, ["modelValue", "disabled", "active-metrics", "is-multi-metric"])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(ScoreGraphCard, {
            "graph-data": _unref(graphData),
            "graph-summary": _unref(graphSummary),
            "filter-time-label": _unref(timeFilter).label,
            metric: _unref(metricFilter) ?? 'nps',
            "is-five-score": isFiveScore.value ?? false,
            "csat-in-percentage": showCsatAsPercent.value,
            loading: _unref(loadingResponseData),
            decimals: _ctx.$companyVars?.decimals,
            "show-error": _unref(hasErrorResponseData),
            "on-reload-click": _unref(fetchResponses)
          }, null, 8, ["graph-data", "graph-summary", "filter-time-label", "metric", "is-five-score", "csat-in-percentage", "loading", "decimals", "show-error", "on-reload-click"]),
          _createVNode(ResponsesSummary, {
            summaries: _unref(responseSummary),
            "time-filter": _unref(timeFilter),
            "response-count": _unref(responseCount),
            loading: _unref(loadingResponseData),
            "show-error": _unref(hasErrorResponseData),
            "on-reload-click": _unref(fetchResponses),
            class: "responses-card"
          }, null, 8, ["summaries", "time-filter", "response-count", "loading", "show-error", "on-reload-click"])
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_7, [
          _createVNode(ActionsList, {
            "data-testid": "fm-dash-recommended-praises-list",
            "user-name": userName.value,
            actions: _unref(promoterActions),
            title: "Recommended Praises",
            loading: _unref(loadingPromoterActions),
            "show-error": _unref(hasErrorPromoterActions),
            "on-reload-click": _unref(fetchActionsPromoter),
            "cards-to-show": actionCardsToShow.value,
            onTriggerAction: openPraiseModal,
            onDismissAction: _unref(onDismissPraise)
          }, null, 8, ["user-name", "actions", "loading", "show-error", "on-reload-click", "cards-to-show", "onDismissAction"])
        ], 512), [
          [_vShow, _unref(showPraiseActionsCard)]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_8, [
          _createVNode(ActionsList, {
            "data-testid": "fm-dash-detractor-actions-list",
            "user-name": userName.value,
            actions: _unref(detractorActions),
            title: "Detractor Actions",
            loading: _unref(loadingDetractorActions),
            icon: _unref(faFaceFrownSlight),
            "show-error": _unref(hasErrorDetractorActions),
            "on-reload-click": _unref(fetchActionsDetractor),
            "cards-to-show": actionCardsToShow.value,
            onTriggerAction: openChat,
            onDismissAction: _unref(onDismissDetractor)
          }, null, 8, ["user-name", "actions", "loading", "icon", "show-error", "on-reload-click", "cards-to-show", "onDismissAction"])
        ], 512), [
          [_vShow, _unref(showDetractorActionsCard)]
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(Scorecard, {
            scorecards: _unref(scorecards),
            loading: _unref(loadingScorecardData),
            metric: _unref(metricFilter) ?? 'nps',
            "time-period": _unref(timeFilter).label,
            "csat-as-percent": showCsatAsPercent.value,
            "is-five-score": isFiveScore.value ?? false,
            decimals: _ctx.$companyVars?.decimals,
            "show-error": _unref(hasErrorScorecardData),
            "on-reload-click": _unref(fetchScorecardData)
          }, null, 8, ["scorecards", "loading", "metric", "time-period", "csat-as-percent", "is-five-score", "decimals", "show-error", "on-reload-click"]),
          _createVNode(Cases, {
            cases: _unref(cases),
            loading: _unref(loadingCasesData),
            "time-filter": _unref(timeFilter),
            "response-count": _unref(casesResponseCount),
            "detractor-count": _unref(graphSummary)?.detractor ?? 0,
            "is-mobile": true,
            "show-error": _unref(hasErrorCasesData),
            "on-reload-click": _unref(fetchCasesData),
            "on-view-cases-click": onViewCasesClicked
          }, null, 8, ["cases", "loading", "time-filter", "response-count", "detractor-count", "show-error", "on-reload-click"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(LeaderboardTable, {
            title: "Team Leaderboard",
            "data-label": "Team Member",
            class: "team-leaderboard",
            leaderboard: _unref(teamLeaderboard),
            icon: _unref(faUserGroup),
            metric: _unref(metricFilter) ?? 'nps',
            "time-period": _unref(timeFilter).label,
            "csat-as-percent": showCsatAsPercent.value,
            loading: _unref(loadingTeamLeaderboard),
            "is-five-score": isFiveScore.value ?? false,
            decimals: _ctx.$companyVars?.decimals,
            "show-error": _unref(hasErrorTeamLeaderboard),
            "on-reload-click": _unref(fetchTeamLeaderboard),
            "rows-to-show": 7
          }, null, 8, ["leaderboard", "icon", "metric", "time-period", "csat-as-percent", "loading", "is-five-score", "decimals", "show-error", "on-reload-click"])
        ])
      ], undefined, true),
      _: 1
    })
  ]))
}
}

})